'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = OffCanvasWrapper;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./off-canvas-wrapper.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH OffCanvasWrapper Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>}  HTML markup for the component
 */
function OffCanvasWrapper(props) {
    var _cx;

    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$isOpen = props.isOpen,
        isOpen = _props$isOpen === undefined ? false : _props$isOpen,
        _props$position = props.position,
        position = _props$position === undefined ? 'left' : _props$position,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id,
        children = props.children;


    var classNames = (0, _classnames2.default)((_cx = {
        'sb-off-canvas-wrapper': true,
        'sb-off-canvas-wrapper--is-open': isOpen
    }, (0, _defineProperty3.default)(_cx, 'sb-off-canvas-wrapper--' + position, position), (0, _defineProperty3.default)(_cx, '' + className, className), _cx));

    return (0, _jsx3.default)('div', {
        className: classNames,
        id: id
    }, void 0, children);
}
// css
//# sourceMappingURL=OffCanvasWrapper.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/offCanvas/OffCanvasWrapper.js
// module id = 586
// module chunks = 0